import React, { useContext } from 'react';
// import { Redirect } from 'react-router-dom';
import { Liveness } from '../Liveness';
import RootContext from '../../context';
import { Canvas } from '../Canvas';

export const Interface = () => {
  const { videoParams, setCtx, setCanvas } = useContext(RootContext);
  // if (!videoParams) return <Redirect to={`${PATH_ROOT}${PATH_INTRO}`}/>;
  // console.log('[Interface]', { videoParams });
  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: '0px',
          left: '50%',
          height: '100%',
        }}
      >
        <Canvas
          videoParams={videoParams}
          setCtx={setCtx}
          setCanvas={setCanvas}
        />
      </div>
      <Liveness />
    </>
  );
};
